import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { getSGirl } from "./detailsContent/details_S–Girl";
import { get2024EarthDay } from "./detailsContent/details_2024Earthday";
import { getTamsuiRiver } from "./detailsContent/details_tamsuiRiver";
import { get2025EarthDayW1 } from "./detailsContent/details_2025EarthdayW1";
import { getEventNcourKiboNtust } from "./detailsContent/details_eventNcourKiboNtust";
import { getEventNcourKibo } from "./detailsContent/details_eventNcourKibo";
import { get2025EarthDayW2 } from "./detailsContent/details_2025EarthdayW2";
import { get2025EarthDayW3 } from "./detailsContent/details_2025EarthdayW3";
import { getLondon } from "./detailsContent/details_london";

@Component({
    selector: "app-blog-details",
    templateUrl: "./blog-details.component.html",
    styleUrls: ["./blog-details.component.scss"],
})
export class BlogDetailsComponent implements OnInit {
    info: string;
    infoDetail: string;
    blockList = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private sanitizer: DomSanitizer
    ) {
        this.route.queryParams.subscribe((params) => {
            this.info = params["info"];
            if (this.info.includes("and")) {
                this.info = this.info.replace("and", "&");
            }
        });
        router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                $(".header-title").removeClass("active");
            }
        });
    }

    ngOnInit() {
        if (this.info == "bd1") {
            this.info = "科學少女與孩子共解人生課題 - 台灣首部青少年科普電影";
            this.blockList = getSGirl(this.sanitizer);
        } else if (this.info === "bd2") {
            this.info = "2024碩達世界地球日";
            this.blockList = get2024EarthDay(this.sanitizer);
        } else if (this.info === "bd3") {
            this.info = "<<淡水河公約>>";
            this.infoDetail = "我響應，為淡水河做一件事";
            this.blockList = getTamsuiRiver(this.sanitizer);
        } else if (this.info === "bd4") {
            this.info = "N-Cour永續淨零平台成果發表會暨捐贈儀式";
            this.blockList = getEventNcourKibo(this.sanitizer);
        } else if (this.info === "bd5") {
            this.info = "數位賦能 × 減碳共力：";
            this.infoDetail = "碳盤查平台捐贈儀式暨淨零論壇";
            this.blockList = getEventNcourKiboNtust(this.sanitizer);
        } else if (this.info === "bd6") {
            this.info = "2025碩達世界地球日W1";
            this.blockList = get2025EarthDayW1(this.sanitizer);
        } else if (this.info === "bd7") {
            this.info = "2025碩達世界地球日W2";
            this.blockList = get2025EarthDayW2(this.sanitizer);
        } else if (this.info === "bd8") {
            this.info =
                "從衝突中前行－\n倫敦「超低排放區」的轉型爭議與制度韌性";
            this.blockList = getLondon(this.sanitizer);
        } else if (this.info === "bd9") {
            this.info = "2025碩達世界地球日W3";
            this.blockList = get2025EarthDayW3(this.sanitizer);
        }
    }
}
